module.exports = __webpack_public_path__ + "img/relativeValuationBase.d558d320.png";